<template>
  <div class="plan-card" :class="[ `plan-card-mode-${mode}` , `plan-card-service-${details.class}`]">
    <div class="plan-badge" v-if="details.badges && details.badges.length > 0">
      <div :class="`plan-${badge.class}`" v-for="badge in details.badges" :key="badge">
        <img v-if="badge.image" :src="`/assets/irinox/icons/plans/${badge.image}`" :alt="badge.name" />
        <span>{{ badge.name }}</span>
      </div>
    </div>

    <div class="p-d-flex p-flex-column p-jc-between" style="height: 100%;">

      <div>
        <div v-if="mode=='active' || mode=='compare'" class="plan-header">
          <img v-if="details.image" :src="`/assets/irinox/icons/plans/${details.image}`" width="32" :alt="details.name" class="plan-header-image"/>
          <span class="plan-name">{{ details.name }}</span>
        </div>
        
        <div class="plan-content">
          
    
          <div class="plan-title" v-if="mode!='active' && details.title">
            {{ details.title }}
          </div>
      
          <div class="plan-subtitle" v-if="mode!='active' && details.subtitle">
            {{ details.subtitle }}
          </div>
      
          <div class="plan-features">
            <div class="plan-feature" v-for="feature in details.features" :key="feature">
              <i v-if="feature.icon" :class="`pi ${feature.icon}`"></i>
              <img v-else-if="feature.image" :src="`/assets/irinox/icons/plans/features/${feature.image}`" width="24" :alt="'Feature'" class="plan-feature-image"/>
              <span>{{ feature.name }}</span>
            </div>
          </div>
    
    
          <div class="plan-expiration" v-if="mode!='compare' && details.expiration!=null">
            <img :src="`/assets/irinox/icons/plans/misc/plan_expire_${mode}.svg`" width="24" :alt="'Expiration'" class="plan-header-image"/>
            <span >{{ $t('plans.expiration_' + mode) }} {{ details.expiration }}</span>
          </div>
    
          <div class="plan-pricebox" v-if="mode=='activable' && (details.price!=null || details.disclaimer!=null)">
            <div v-html="details.price" class="plan-price"></div>
            <div class="plan-disclaimer">{{ details.disclaimer }}</div>
          </div>
    
          
          
          
        </div>
      </div>

      <div class="plan-footer" v-if="mode!='compare' || (mode=='compare' && details.events?.activate!=null)" :class="details.events?.contract ? 'p-ai-start' : 'p-ai-center'">
        
        
        <div v-if="mode=='active' && details.events?.contract!=null" class="p-d-flex p-flex-column" style="gap: 15px;">
          <div class="plan-contract" @click="downloadContract(plansMapping[$i18n.locale=='en-US'? 'us' : $i18n.locale][details.events.contract.toLowerCase()].terms_1)">{{ $t('plans.contract_1') }}</div>
          <div class="plan-contract" @click="downloadContract(plansMapping[$i18n.locale=='en-US'? 'us' : $i18n.locale][details.events.contract.toLowerCase()].terms_2)">{{ $t('plans.contract_2') }}</div>
        </div>
        <div v-else-if="mode=='activable' && details.events?.activate!=null" class="plan-button" @click="handleActivate">{{ $t('plans.activate') }}</div>
        <div v-else-if="mode=='compare' && details.events?.activate!=null" class="plan-button" @click="handleActivate">{{ $t('plans.select_device') }}</div>
        <div v-else-if="mode=='activable' && details.events?.select!=null" class="plan-button" @click="$emit('click:select')">{{ $t('plans.select') }}</div>

        <div v-if="mode=='activable' && details.events?.discover!=null" class="plan-discover" @click="$emit('click:discover')">{{ $t('plans.discover') }}</div>

        <div v-if="(mode=='activable' || mode=='compare') && details.events?.activate!=null" class="">
          <div class="p-field-checkbox plans-terms">
            <Checkbox v-model="terms1" :binary="true" 
              :class="{'p-invalid': submitted && !terms1}" :ariaLabel="$t('plans.terms_1')"/>
            <p v-html="$t('plans.terms_1', { url: plansMapping[$i18n.locale=='en-US'? 'us' : $i18n.locale][details.events.activate.toLowerCase()].terms_1 })" 
              :class="{'plans-terms-error': submitted && !terms1}"></p>
          </div>
          <div class="p-field-checkbox plans-terms">
            <Checkbox v-model="terms2" :binary="true" 
              :class="{'p-invalid': submitted && !terms2}" :ariaLabel="$t('plans.terms_2')"/>
            <p v-html="$t('plans.terms_2', { url: plansMapping[$i18n.locale=='en-US'? 'us' : $i18n.locale][details.events.activate.toLowerCase()].terms_2 })" 
              :class="{'plans-terms-error': submitted && !terms2}"></p>
          </div>
        </div>


      </div>
    </div>

    

  </div>
</template>

<script>
export default {
  emits: ['click:activate', 'click:select', 'click:discover'],
  components: {
  },
  setup() {
  },
  props: {
    mode: {
      type: String,
      default: 'default'
      // compare, active, activable
    },
    details: {
      type: Object,
      default: () => ({})
    },
    plansMapping: Object,
  },
  data() {
    return {
          submitted: false,
          terms1: false,
          terms2: false,
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    handleActivate() {
      this.submitted = true;
      if (!this.terms1 || !this.terms2) {
        return;
      }
      this.$emit('click:activate', this.details.events.activate);
    },
    downloadContract(contractUrl) {
      this.$window.open(contractUrl, '_blank');
    }
  },
}
</script>

<style scoped></style>